let language = {
    PRODUCT_PRICE_TABLE_QTY: "Qty",
    PRODUCT_PRICE_TABLE_US_COUNTRY_PRICE: "US",
    PRODUCT_PRICE_TABLE_OTHER_COUNTRY_PRICE: "Others",
};

export { language }